import { Link, useLocation } from "react-router-dom";

/* TravelerPulse.pro brand mark:
   - Globe with an orbiting plane path (SVG, no external asset).
   - Wordmark leads with `TravelerPulse.pro`, MSP App below as sub-tag.
   - Tenant-aware: on IndianAirports (`/india/*`) and HotelsPulse
     (`/hotelspulse*`) surfaces the sub-tag is auto-hidden so the alt-brand
     strips read cleanly on their own domains.
   Sizes are set via `size` prop: sm | md | lg. */

export default function BrandMark({ size = "md", to = "/", subline = false, testid = "brand-mark" }) {
  const { pathname } = useLocation();
  const tenantHidesSub = pathname.startsWith("/india/") || pathname.startsWith("/hotelspulse");
  const showSub = subline && !tenantHidesSub;
  const sizes = {
    sm: { icon: 24, iconSm: 28, title: "text-base sm:text-lg",                    tag: "text-[9px]" },
    md: { icon: 26, iconSm: 32, title: "text-sm sm:text-2xl lg:text-3xl",         tag: "text-[9px] sm:text-[10px] lg:text-[11px]" },
    lg: { icon: 48, iconSm: 56, title: "text-2xl sm:text-3xl lg:text-4xl",        tag: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  const inner = (
    <div className="inline-flex items-center gap-1.5 sm:gap-2.5 min-w-0" data-testid={testid}>
      <span className="sm:hidden shrink-0"><BrandIcon size={s.icon} /></span>
      <span className="hidden sm:inline-flex shrink-0"><BrandIcon size={s.iconSm} /></span>
      <span className="leading-tight min-w-0">
        <span className={`font-serif font-900 tracking-tight ${s.title} whitespace-nowrap`}>
          <span className="text-primary">Traveler</span><span className="text-teal-600">Pulse</span><span className="text-primary">.pro</span><sup className="hidden sm:inline text-[0.5em] text-primary/60 ml-0.5">™</sup>
        </span>
        {showSub && (
          <span className={`${s.tag} hidden sm:block font-mono tracking-[0.14em] uppercase text-emerald-700 leading-none mt-1`}>
            My Social Pulse App
          </span>
        )}
      </span>
    </div>
  );
  return to ? <Link to={to} className="tap">{inner}</Link> : inner;
}

/* Globe with orbiting plane — SVG mark, colour picks up from tokens */
export function BrandIcon({ size = 40 }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true"
      className="shrink-0 drop-shadow-sm">
      <defs>
        <linearGradient id="msp-globe" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b7fbf" />
          <stop offset="100%" stopColor="#14304F" />
        </linearGradient>
      </defs>
      {/* globe */}
      <circle cx="30" cy="32" r="18" fill="url(#msp-globe)" />
      {/* meridians */}
      <g stroke="#a7e0d8" strokeWidth="1.2" fill="none" opacity="0.9">
        <ellipse cx="30" cy="32" rx="18" ry="9" />
        <ellipse cx="30" cy="32" rx="9" ry="18" />
        <path d="M12 32h36" />
      </g>
      {/* orbit path */}
      <path d="M6 42 Q 30 4, 58 22" fill="none" stroke="#14b8a6" strokeWidth="2.2" strokeLinecap="round" strokeDasharray="1 4" opacity="0.9" />
      {/* plane */}
      <g transform="translate(50 18) rotate(28)">
        <path d="M0 0 L10 3 L4 6 L2 10 L0 6 L-6 5 Z" fill="#14b8a6" />
      </g>
    </svg>
  );
}
